import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    PreconditioningTechnology,
    StorageType,
} from 'app/enums/label.enums'
import {
    StorageTableType,
} from '../../serviceCenters.types'

const columns = (l: (l: string) => string): RichTableColumns<keyof StorageTableType>[] => {
    return [
        {
            id: 'storageType',
            headerProps: {
                children: l('ServiceCenterStorage.storageType'),
            },
            mapCellProps: 'storageType',
            componentName: 'EnumValue',
            allowedValuesEnum: StorageType,
        },
        {
            id: 'storageCapacity',
            headerProps: {
                children: l('ServiceCenterStorage.storageCapacity'),
            },
            mapCellProps: ({
                storageCapacity,
            }) => {
                return {
                    children: `${storageCapacity ?? '-'}`,
                }
            },
        },
        {
            id: 'preconditioningTechnology',
            headerProps: {
                children: l('ServiceCenterStorage.preconditioningTechnology'),
            },
            mapCellProps: 'preconditioningTechnology',
            componentName: 'EnumValue',
            allowedValuesEnum: PreconditioningTechnology,
        },
        {
            id: 'preconditioningCapacity',
            headerProps: {
                children: l('ServiceCenterStorage.preconditioningCapacity'),
            },
            mapCellProps: ({
                preconditioningCapacity,
            }) => {
                return {
                    children: `${preconditioningCapacity ?? '-'}`,
                }
            },
        },
    ]
}

export default columns
